"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APNS_TOPIC = exports.LEADER_YEAR = exports.MILLISECONDS_IN_DAY = exports.MILLISECONDS_IN_HOUR = exports.MILLISECONDS_IN_MINUTE = exports.HOURS_IN_DAY = exports.MINUTES_IN_HOUR = exports.SECONDS_IN_MINUTE = exports.MILLISECONDS_IN_SECOND = exports.MAX_PASSWORD_LENGTH = exports.MIN_PASSWORD_LENGTH = exports.MAX_NAME_LENGTH = exports.MIN_NAME_LENGTH = void 0;
exports.MIN_NAME_LENGTH = 1;
exports.MAX_NAME_LENGTH = 60;
exports.MIN_PASSWORD_LENGTH = 5;
exports.MAX_PASSWORD_LENGTH = 60;
exports.MILLISECONDS_IN_SECOND = 1000;
exports.SECONDS_IN_MINUTE = 60;
exports.MINUTES_IN_HOUR = 60;
exports.HOURS_IN_DAY = 24;
exports.MILLISECONDS_IN_MINUTE = exports.MILLISECONDS_IN_SECOND * exports.SECONDS_IN_MINUTE;
exports.MILLISECONDS_IN_HOUR = exports.MILLISECONDS_IN_MINUTE * exports.MINUTES_IN_HOUR;
exports.MILLISECONDS_IN_DAY = exports.MILLISECONDS_IN_HOUR * exports.HOURS_IN_DAY;
/**
 * A hack to label a youth kid as a leader
 */
exports.LEADER_YEAR = 999;
exports.APNS_TOPIC = "com.ashleycheung.youthcampapp";
